module.exports = __webpack_public_path__ + "static/media/r-arrow.ab008da1.svg";